import ResultChecker from "./ResultChecker";
import Constants from "../../components/constants";
//import { unstable_renderSubtreeIntoContainer } from "react-dom";

export default class DefaultResultChecker extends ResultChecker{
    constructor(exercise){
        super();

        if(!exercise.getStepCount){
            throw new Error("Invalid exercise object passed");
        }
        this.exercise = exercise;
    }

    /*
    Sharing exercise information in function check
    ----------------------------------------------
    Which information?
    1. plus sign optional (i.e. can be removed from user input)
    2. leading zeros optional (i.e. can be removed from user input)
    3. trailing zeros (in fractional part) optional (i.e. can be removed from user input)
    Notes
    - In Modes.js the ResultChecker (aka DefaultResultChecker) is assigned to an exercise.
    - This is not only dependent on type of exercise, but also on the step (where available)
    - An empty string must not be recognized as value 0
    Options for realization
    1. function check knows type of exercise - bad due to separation of concerns
    2. check can determine what optional parts exist
    3. check has parameters about what optional parts exist
    Decision: 2. - put information it into every ResultItem during creation
    */

    check(value, index){
        // prevent user input from being accepted if expected result is 0 and
        // previous wrong input was deleted completely to an empty string in input field
        if (value.length === 0) {
            return false;
        }

        let result = String(this.exercise.getResultAtIndex(index).getValue()).toLowerCase();
        value = value.toLowerCase();
        let correct = value === result;

        //ignore + at first place in input if given, and if it is optional
        // if the string contains a + only, do not remove it 
        // (empty string is recognized as 0, which is correct if 0 is the expected result)
        if(!correct && this.exercise.getResultAtIndex(index).plusCanBeRemoved()){
            // remove from user input, if available
            value = this.removeLeadingPlus(value);
            // remove from required result, if available
            result = this.removeLeadingPlus(result);
            // compare values again
            correct = value === result;
        }

        //Ignore leading zeroes if available, and if they are optional
        if(!correct && this.exercise.getResultAtIndex(index).leadingZerosCanBeRemoved()){
            // remove from user input, if available
            // remove leading "-" first, if available, and add it afterwards again
            let valueIsPositive = true;
            if(value.indexOf(Constants.MINUS) === 0){
                valueIsPositive = false;
                value = value.substring(1, value.length);
            }
            value = this.removeLeadingZeros(value);
            if (!valueIsPositive){
                value = Constants.MINUS + value;
            }

            // remove from required result, if available
            result = this.removeLeadingZeros(result);
            // compare values again
            correct = value === result;
        }

        //Ignore trailing zeroes if available, and if they are optional
        if(!correct && this.exercise.getResultAtIndex(index).trailingZerosCanBeRemoved()){
            // remove from user input, if available
            value = this.removeTrailingZeros(value);
            // remove from required result, if available
            result = this.removeTrailingZeros(result);
            // compare values again
            correct = value === result;
        }

        // Kept for now: Is it really necessary?
        // application restricted to values where trailing zeros can be removed
        //Remove .0 at the end results, if available
        if(!correct && this.exercise.getResultAtIndex(index).trailingZerosCanBeRemoved()){
            // remove from user input, if available
            value = this.removeZeroDecimalPart(value);
            // remove from required result, if available
            result = this.removeZeroDecimalPart(result);
            // compare values again
            correct = value === result;
        }
        return correct;
    }

    removeLeadingPlus(str){
        // leave it untouched, if it is a + only
        // note: +-xxx becomes -xxx which is mathematically correct
        if(str.indexOf(Constants.PLUS) === 0 && str.length > 1){
            str = str.substring(1, str.length);
        }
        return str;
    }

    removeLeadingZeros(str){
        while(str.indexOf("0") === 0){
            str = str.substring(1, str.length);
        }
        if (str.length === 0){ // "" -> "0"
            str = "0";
        }
        else if (str.indexOf(Constants.COMMA) === 0){ // ".xxx" -> "0.xxx"
            str = "0" + str;
        }
        return str;
    }

    removeTrailingZeros(str){
        if (str.indexOf(Constants.COMMA) !== -1) {
            while(str.lastIndexOf("0") === str.length-1){
                str = str.substring(0, str.length-1);
            }
            if (str.indexOf(Constants.COMMA) === str.length-1){ // "xxx." -> "xxx.0"
                str = str + "0";
            }
        }
        return str;
    }

    removeZeroDecimalPart(str){
        const commaIndex = str.indexOf(Constants.COMMA);
        if(commaIndex !== -1){
            if(str.substr(commaIndex, str.length) === ".0"){
                str = str.substring(0, commaIndex);
            }
        }
        return str;
    }
}